import React, { useState } from "react";
import moment from "moment";
import "./PortfolioTable.scss";
import ReusableTable from "../../../Reuseable/ReusableTable/ReusableTable";
import EllipsisMenu from "../../../Reuseable/EllipsisMenu/EllipsisMenu";
import { ReactComponent as Edit } from "../../../assets/Icons/portfolioEditIcon.svg";
import { ReactComponent as Cong } from "../../../assets/Icons/portfolioCongIcons.svg";
import { ReactComponent as Trash } from "../../../assets/Icons/portfolioTrashIcon.svg";
import { ReactComponent as Upload } from "../../../assets/Icons/uploadIconPortfolio.svg";
import PortfolioUploadedFiles from "../PortfolioUploadedFiles/PortfolioUploadedFiles";
import PortfolioModal from "../PortfolioModal/PortfolioModal";
import { Button, Skeleton } from "antd";
import { useDispatch } from "react-redux";
import DeleteUserModal from "../../AgencyComp/UserComp/DeleteUserModal";
import { useSelector } from "react-redux";
import { deletePortfolio } from "../../../assets/api/agency";
import { fetchPortfolios } from "../../../store/portfolioSlice";
import toast from "react-hot-toast";
import { ExportOutlined, RedoOutlined, UndoOutlined } from "@ant-design/icons";
import {
  downloadPortfolioFile,
  unarchivePortfolio,
} from "../../../assets/api/portfolio";
import { formatCurrency } from "../../../assets/helpers";

const PortfolioTable = ({
  data = [],
  loading,
  setFile,
  handleCreatePortfolio,
  load,
  isEditModalOpen,
  setIsEditModalOpen,
  file,
  setOpenDatewiseExportModal,
  setSelectedItem,
  loadingExport = false,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedPortfolio, setSelectedPortfolio] = useState(null);
  const [isUploadedFiles, setIsUploadedFiles] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [portfolioToDelete, setPortfolioToDelete] = useState(null);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadingUndo, setLoadingUndo] = useState(false);

  const [params, setParams] = useState({});

  const { format } = useSelector((state) => state.priceFormat);

  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);

  const handleDeleteClick = (portfolio) => {
    setPortfolioToDelete(portfolio);
    setIsDeleteModalOpen(true);
  };


  const handleDeleteConfirm = async () => {
    if (!portfolioToDelete?.id || !token) return;

    try {
      setLoadingDelete(true);
      const res = await deletePortfolio({ portfolio_id: portfolioToDelete.id }, token);
      if (res?.status === 200) {
        toast.success(res?.data?.message || 'Portfolio deleted successfully');
        setLoadingDelete(false);
        dispatch(fetchPortfolios());
      }
      setIsDeleteModalOpen(false);
    } catch (err) {
      console.error("Failed to delete portfolio", err);
      toast.error(err?.message || "Failed to delete portfolio");
      setLoadingDelete(false)
    }
  };
  const handleExportPortfolio = async (item) => {
    setSelectedPortfolio(item);
    setOpenDatewiseExportModal(true);
    setSelectedItem(item);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    return moment(dateStr).format("DD MMM YYYY");
  };

    const formatCurrencyNormal = (val) => {
    if (!val || isNaN(val)) return "-";
    return `₹${Number(val).toLocaleString("en-IN")}`;
  };

  const handleEditClick = (portfolio) => {
    setSelectedPortfolio({
      name: portfolio.name || "",
      acquiredOn: portfolio.acquired_on || null,
      totalCases: portfolio.total_cases || "",
      totalPOS: portfolio.total_pos || "",
      total_tos: portfolio.total_tos || "",
      recovery: portfolio.recovery || "",
      recoveryPercent: portfolio.recovery_percent || "",
      uploadedFiles: portfolio.uploadedFiles || [],
      id: portfolio?.id,
    });
    setIsEditModalOpen(true);
    setSelectedPortfolio(portfolio)
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (val) =>
        loading ? <Skeleton.Input size="small" active /> : val || "-",
    },
    {
      title: "Added On",
      dataIndex: "acquired_on",
      key: "acquired_on",
      render: (val) =>
        loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          formatDate(val) ?? "-"
        ),
    },
    {
      title: "Total Cases",
      dataIndex: "total_cases",
      key: "total_cases",
      render: (val) =>
        loading ? (
          <Skeleton.Input size="small" active />
        ) : val !== null && val !== undefined ? (
          `${val} accounts`
        ) : (
          "-"
        ),
    },
    {
      title: "Total POS",
      dataIndex: "total_pos",
      key: "total_pos",
      render: (val) =>
        loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          formatCurrency(val,format) ?? "-"
        ),
    },
    {
      title: "Total TOS",
      dataIndex: "total_tos",
      key: "total_tos",
      render: (val) =>
        loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          formatCurrency(val,format) ?? "-"
        ),
    },
    {
      title: "Recovery",
      key: "recovery",
      render: (_, record) => {
        const recoveryValue = Number(record.recovery) || 0;
        const recoveryPercent = Number(record.recovery_percent) || 0;
        return loading ? (
          <Skeleton.Input size="small" active />
        ) : recoveryValue <= 0 ? (
          0
        ) : (
          `${formatCurrency(recoveryValue, format)} (${recoveryPercent}%)`
        );
      },
    },
    {
      title: "",
      key: "actions",
      render: (_, record) =>
        loading ? (
          <Skeleton.Input size="small" active />
        ) : record?.is_archived ? (
          <Button
            onClick={() => handleRevertPortfolio(record)}
            loading={loadingUndo}
            type="text"
          >
            {loadingUndo ? null : <UndoOutlined />}
          </Button>
        ) : loadingExport === record?.id ? (
          "Downloading..."
        ) : (
          <EllipsisMenu
            options={[
              {
                icon: <Edit />,
                label: "Edit Details",
                highlight: true,
                onClick: () => handleEditClick(record),
              },
              {
                icon: <Cong />,
                label: "Config",
                highlight: false,
              },
              {
                icon: <Trash />,
                label: "Delete",
                highlight: false,
                onClick: () => handleDeleteClick(record),
              },
              {
                icon: <Upload />,
                label: "Show Uploaded Files",
                highlight: false,
                onClick: () => {
                  setIsUploadedFiles(true);
                  setSelectedPortfolio(record);
                },
              },
              {
                icon: <ExportOutlined />,
                label: "Export",
                highlight: false,
                onClick: () => handleExportPortfolio(record),
              },
            ]}
          />
        ),
    },
  ];

  const handleRevertPortfolio = async (portfolio) => {
    try {
      setLoadingUndo(true);
      const res = await unarchivePortfolio(portfolio?.id, token);
      if (res?.status === 200) {
        toast.success(res?.data?.message || "Portfolio reverted successfully");
        dispatch(fetchPortfolios());
        setLoadingUndo(false);
      }
    } catch (error) {
      setLoadingUndo(false);
    }
  }

  return (
    <>
      <div className="portfolioTableMain">
        <ReusableTable
          columns={columns}
          dataSource={data}
          rowKey={(record) => record.id || record.name}
          bordered
          pageSize={pageSize}
          CurrentPageNo={currentPage}
          totalItems={data.length}
          setPageSize={setPageSize}
          triggerChange={(page, size) => {
            setCurrentPage(page);
            setPageSize(size);
          }}
          rowClass={(record) => record.is_archived ? 'archived-row' : ''}
        />
      </div>

      {isEditModalOpen && (
        <PortfolioModal
          isOpen={isEditModalOpen}
          onClose={() => setIsEditModalOpen(false)}
          userData={selectedPortfolio}
          setUserData={setSelectedPortfolio}
          setFile={setFile}
          load={load}
          file={file}
          mode="edit"
          onSave={(data) => {
            handleCreatePortfolio({
              ...data,
              is_edit: true,
              id: selectedPortfolio?.id,
            });
          }}
        />
      )}

      {isDeleteModalOpen && (
        <DeleteUserModal
          userStatus={"Active"}
          open={isDeleteModalOpen}
          onClose={() => setIsDeleteModalOpen(false)}
          onDelete={handleDeleteConfirm}
          message={
            <>
              Are you sure you want to <br /> delete this portfolio?
            </>
          }
          loading={loadingDelete}
        />
      )}

      {isUploadedFiles && (
        <PortfolioUploadedFiles
          isVisible={isUploadedFiles}
          onClose={() => setIsUploadedFiles(false)}
          selectedPortfolio={selectedPortfolio}
        />
      )}
    </>
  );
};

export default PortfolioTable;
